import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGalaxy: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="galaxy, dark-hole"><path d="M1.5 10.897C4.0625 3.50607 17.9 4.64303 17.9 10.7053C17.9 14.1426 11.6307 14.8456 10.4152 13.0808C9.5147 11.7733 13.9522 11.8856 13.0848 10.6262C11.8693 8.86138 5.6 9.56426 5.6 13.0015C5.6 19.3451 20.4625 20.5624 22 13.1713" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconGalaxy;
